import React from 'react';

import { CheckboxField } from 'components/Form';
import { RecaptchaInput } from 'components/RecaptchaInput';
import { configValue } from 'utils/config';

import Field from './Field';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RecaptchaField = () =>
  configValue('google', 'recaptcha', 'enabled') ? (
    <Field
      name="gRecaptchaResponse"
      renderInput={({ values, updateValue }) => (
        <RecaptchaInput
          key={values.recaptchaKey}
          onChange={(gRecaptchaResponse) => {
            updateValue(gRecaptchaResponse);
          }}
        />
      )}
    />
  ) : (
    <CheckboxField
      name="gRecaptchaResponse"
      label="I'm not a robot"
      valueToChecked={{ recaptcha_mock: true, nope: false }}
    />
  );

// eslint-disable-next-line import/no-default-export
export default RecaptchaField;
